import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import { MenuItem } from "react-pro-sidebar";
import Header from "../../components/Header";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { tokens } from "../../theme";
import { Delete, Edit, SaveAlt } from "@mui/icons-material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import NotificationToaste from "../global/NotificationToaste";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { INSTITUTE_DEFAULT_VALUE } from "./InstituteUtils";
import { getPayload, setPostPayload, setPutPayload } from "../../services/api";

const Institutes = () => {
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]); // load all cities
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState([
    { value: "institute", label: "Institute" },
    { value: "contractor", label: "Contractor" },
  ]);
  const [officers, setOfficers] = useState([]);
  const [mainData, setMainData] = useState(INSTITUTE_DEFAULT_VALUE);

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    setLoading(true);

    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/clientreg")
      .then(function (response) {
        // console.log(response.data.cities);
        console.log("------------", response.data);
        setCities(response.data.cities);
        setDistricts(response.data.districts);
        setData(response.data.tableData);
        setOfficers(response.data.allUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const reloadTableData = async () => {
    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/institute/all")
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
  };

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleSaveDBData = async () => {
    if (!update) {
      setLoading(true);
      const dataObj = {
        institute: mainData.institute.institute,
        instituteName: mainData.instituteName.instituteName,
        contactNo: mainData.contactNo.contactNo,
        mobileNo: mainData.mobileNo,
        email: mainData.email.email,
        address1: mainData.address1,
        address2: mainData.address2,
        city: mainData.city.city,
        district: mainData.district.district,
        actice: mainData.active,
        assignUser: { id: mainData.assignUser.id, role: "USER" },
      };

      await setPostPayload
        .setPayloadData("/institute", dataObj)
        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          resetMainData();
          reloadTableData();
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      const dataObj = {
        id: mainData.instituteName.id,
        institute: mainData.institute.institute,
        instituteName: mainData.instituteName.instituteName,
        contactNo: mainData.contactNo.contactNo,
        mobileNo: mainData.mobileNo,
        email: mainData.email.email,
        address1: mainData.address1,
        address2: mainData.address2,
        city: mainData.city.city,
        district: mainData.district.district,
        active: mainData.active,
        assignUser: { id: mainData.assignUser.id, role: "USER" },
      };

      await setPutPayload
        .setPayloadData("/institute/" + mainData.instituteName.id, dataObj)
        .then(function (response) {
          console.log(response);
          setUpdate(false);
          setMessage("Data Updated successfully..!");
          setMessageType("success");
          setOpen(true);
          resetMainData();
          setData(response.data);
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  const resetMainData = () => {
    setUpdate(false);
    setMainData({
      institute: {
        institute: "",
        error: false,
      },
      instituteName: {
        instituteName: "",
        id: "",
        error: false,
      },
      mobileNo: "",
      contactNo: {
        contactNo: "",
        error: false,
      },
      email: {
        email: "",
        error: false,
      },
      address1: "",
      address2: "",
      city: {
        city: "",
        error: false,
      },
      district: {
        district: "",
        error: false,
      },
      active: true,
      assignUser: { id: "", error: false },
    });
  };

  const handleFormSubmit = () => {
    // console.log(mainData);
    if (
      mainData.institute.institute === "" ||
      mainData.instituteName.instituteName === "" ||
      mainData.contactNo.contactNo === "" ||
      mainData.email.email === "" ||
      mainData.district.district === "" ||
      mainData.assignUser.id == ""
    ) {
      setMainData((pre) => ({
        ...pre,
        institute: {
          ...pre.institute,
          error: pre.institute.institute === "" ? true : false,
        },
        instituteName: {
          ...pre.instituteName,
          error: pre.instituteName.instituteName === "" ? true : false,
        },
        contactNo: {
          ...pre.contactNo,
          error: pre.contactNo.contactNo === "" ? true : false,
        },
        email: {
          ...pre.email,
          error: pre.email.email === "" ? true : false,
        },
        district: {
          ...pre.district,
          error: pre.district.district === "" ? true : false,
        },
        assignUser: {
          ...pre.assignUser,
          error: pre.assignUser.id === "" ? true : false,
        },
      }));
    } else {
      handleSaveDBData();
    }
  };

  const handleLoadEditDataInstitute = async (data) => {
    setLoading(true);

    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/institute/" + data.id)
      .then(function (response) {
        setUpdate(true);
        setMainData((pre) => ({
          ...pre,
          institute: {
            ...pre.institute,
            institute: response.data.institute,
          },
          instituteName: {
            ...pre.instituteName,
            instituteName: response.data.instituteName,
            id: response.data.id,
          },
          contactNo: {
            ...pre.contactNo,
            contactNo: response.data.contactNo,
          },
          mobileNo: response.data.mobileNo,
          email: {
            ...pre.email,
            email: response.data.email,
          },
          address1: response.data.address1,
          address2: response.data.address2,
          city: {
            ...pre.city,
            city: response.data.city,
          },
          district: {
            ...pre.district,
            district: response.data.district,
          },
          active: response.data.active,
          assignUser: {
            ...pre.assignUser,
            id: response.data.assignUser?.id,
          },
        }));
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
        setLoading(false);
      });
  };

  const [data, setData] = useState([]);
  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 250,
      },
      {
        accessorKey: "contactNo",
        header: "Contact No",
        size: 80,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 150,
      },
      {
        accessorKey: "city",
        header: "City",
        size: 100,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows
      sx: { padding: "10px" },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        // sx={{ padding: "10px" }}
        key={1}
        onClick={() => {
          handleLoadEditDataInstitute(row.original);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Edit />}>
          <Typography variant="subtitle1">Edit</Typography>
        </Button>
      </MenuItem>,
      <MenuItem key={2}>
        <Button variant="text" fullWidth startIcon={<Delete />}>
          <Typography variant="subtitle1">Delete</Typography>
        </Button>
      </MenuItem>,
    ],
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "70%" }}
        elevation={3}
      >
        <Header
          title="Institutes / Client"
          subtitle="Add / Update / Delete Institutes"
        />

        <Box
          display="grid"
          gap="8px"
          gridTemplateColumns="repeat(12, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 12",
            },
          }}
        >
          <TextField
            select
            label="Institute or contractor"
            fullWidth
            size="small"
            defaultValue=""
            error={mainData.institute.error}
            sx={{ gridColumn: "span 2" }}
            value={mainData.institute.institute}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                institute: {
                  ...pre.institute,
                  institute: e.target.value,
                },
              }));
            }}
          >
            {type.map((data) => (
              <MenuItemMui key={data.value} value={data.value}>
                {data.label}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            fullWidth
            variant="outlined"
            error={mainData.instituteName.error}
            type="text"
            label="Institute Name"
            size="small"
            name="ins_name"
            sx={{ gridColumn: "span 4" }}
            value={mainData.instituteName.instituteName}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                instituteName: {
                  ...pre.instituteName,
                  instituteName: e.target.value,
                },
              }));
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Contact No"
            name="con_no"
            sx={{ gridColumn: "span 2" }}
            error={mainData.contactNo.error}
            value={mainData.contactNo.contactNo}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                contactNo: {
                  ...pre.contactNo,
                  contactNo: e.target.value,
                },
              }));
            }}
          />

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="WhatsApp No"
            name="mob_no"
            sx={{ gridColumn: "span 2" }}
            value={mainData.mobileNo}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                mobileNo: e.target.value,
              }));
            }}
          />

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Email"
            error={mainData.email.error}
            name="email"
            sx={{ gridColumn: "span 2" }}
            value={mainData.email.email}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                email: { ...pre.email, email: e.target.value },
              }));
            }}
          />

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Address Line 1"
            name="address_line1"
            sx={{ gridColumn: "span 2" }}
            value={mainData.address1}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                address1: e.target.value,
              }));
            }}
          />

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label="Address Line 2"
            name="address_line2"
            sx={{ gridColumn: "span 4" }}
            value={mainData.address2}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                address2: e.target.value,
              }));
            }}
          />
          <TextField
            select
            label="City"
            fullWidth
            size="small"
            error={mainData.city.error}
            defaultValue=""
            sx={{ gridColumn: "span 2" }}
            value={mainData.city.city}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                city: {
                  ...pre.city,
                  city: e.target.value,
                },
              }));
            }}
          >
            {cities.map((data) => (
              <MenuItemMui key={data.id} value={data.city}>
                {data.city}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            select
            label="District"
            fullWidth
            error={mainData.district.error}
            size="small"
            defaultValue=""
            sx={{ gridColumn: "span 2" }}
            value={mainData.district.district}
            onChange={(e) => {
              e.preventDefault();
              setMainData((pre) => ({
                ...pre,
                district: {
                  ...pre.district,
                  district: e.target.value,
                },
              }));
            }}
          >
            {districts.map((data) => (
              <MenuItemMui key={data.id} value={data.name}>
                {data.name}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            select
            label="Assign Technical Officer"
            fullWidth
            size="small"
            helperText={mainData.assignUser.helperText}
            error={mainData.assignUser.error}
            value={mainData?.assignUser?.id}
            onChange={(e) => {
              setMainData((pre) => ({
                ...pre,
                assignUser: {
                  ...pre.assignUser,
                  id: e.target.value,
                  role: "USER",
                },
              }));
            }}
            sx={{
              marginBottom: "5px",
              gridColumn: "span 2",
            }}
          >
            {officers?.map((option) => (
              <MenuItemMui key={option.id} value={option.id}>
                {option.titles.title +
                  " " +
                  option.firstName +
                  " " +
                  option.lastName}
              </MenuItemMui>
            ))}
          </TextField>
          <FormGroup
            sx={{ paddingLeft: "3px", margin: 0, gridColumn: "span 1" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  name="active"
                  // value={mainData.active}
                  checked={mainData.active}
                  onChange={(e) =>
                    setMainData((pre) => ({ ...pre, active: e.target.checked }))
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Active"
            />
          </FormGroup>
        </Box>
        <Divider sx={{ marginTop: "5px" }} />
        <Box
          sx={{ marginTop: "10px" }}
          display="flex"
          justifyContent="flex-end"
          marginBottom="1px"
        >
          <Button
            type="button"
            loading={loading}
            startIcon={<SaveAlt />}
            color="secondary"
            variant="contained"
            onClick={handleFormSubmit}
          >
            {update ? "Update Data" : "Save Data"}
          </Button>
        </Box>
      </Paper>
      <Paper
        sx={{
          padding: "15px",
          borderRadius: "8px",
          width: "70%",
          marginTop: "15px",
        }}
        elevation={3}
      >
        <Header title="View All" subtitle="Update / Delete " />

        <MaterialReactTable table={table} />
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default Institutes;
